import {
  Component,
  inject,
  Input,
  Output,
  EventEmitter,
  OnInit,
} from '@angular/core';
import { AppConfigSettings } from '@arc/arc-shared-frontend';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'shared-remote-card-capture-qrcode',
  templateUrl: './wpx-qrcode.component.html',
  styleUrl: './wpx-qrcode.component.scss',
})
export class WpxQrcodeComponent implements OnInit {
  // Required inputs
  @Input({ required: true }) paymentAccountNumber!: string;
  @Input({ required: true }) sessionId!: string;
  @Input({ required: true }) tenantId!: string;
  @Input({ required: true }) authToken!: string;
  @Input() wSessionId: string;

  // Output for close event
  @Output() close = new EventEmitter<void>();

  // QR code configuration
  readonly size = 350;

  // Simple property - calculated once on init
  qrCodeUrl!: string;

  private readonly appConfig = inject(AppConfigSettings);
  private readonly baseUrl = this.appConfig.getconfig('frontendHostUrl');

  ngOnInit(): void {
    // Calculate URL once on initialization
    this.qrCodeUrl = this.generateQrCodeUrl();
  }

  // Generate QR
  private generateQrCodeUrl(): string {
    const params = [
      `sessionId=${encodeURIComponent(this.sessionId)}`,
      `wSessionId=${encodeURIComponent(this.wSessionId)}`,
      `token=${encodeURIComponent(this.authToken)}`,
    ].join('&');
    return `${this.baseUrl}/wallet/${this.tenantId}/${this.paymentAccountNumber}/capture/card?${params}`;
  }
}
